export default __webpack_public_path__ + "static/media/cancel.ce52e5e7.png";